export var DefaultTournamentStandingsColumns;
(function (DefaultTournamentStandingsColumns) {
    DefaultTournamentStandingsColumns["FIO"] = "FIO";
    DefaultTournamentStandingsColumns["Gender"] = "Gender";
    DefaultTournamentStandingsColumns["AgeGroup"] = "AgeGroup";
    DefaultTournamentStandingsColumns["Kilometers"] = "Kilometers";
})(DefaultTournamentStandingsColumns || (DefaultTournamentStandingsColumns = {}));
